var img = "/static/661cfa050c339dd9.png";

export { img as default };
//# sourceMappingURL=img.png.js.map
